import updatePreference from '@/repositories/Forms/updatePreference'

const updatePreferenceCenter = {
  async post(data: any) {
    return (await updatePreference.updatePreference()).post('/moengage-subscription-v2', data)
  }
}

export default updatePreferenceCenter
